jQuery(document).ready(function($){

    // $(window).on('load',function(){
    //   if ($(window).width() > 1040){
    //     var sidebar = new StickySidebar('.sidebar', {
    //       topSpacing: $('.section-header').outerHeight() + 20,
    //       bottomSpacing: 100,
    //       containerSelector: '.product__grid',
    //       innerWrapperSelector: '.sidebar__inner'
    //     });
    //   }
    // });

  
   
  
    $(document).on('click', '.custom-close-btn', function() {
      $.magnificPopup.close();
    });

    
    // Customize Funnel
    const apiEndpoint = 'https://api.egclothing.co.uk';
    const customizeProduct = $('#castle-customize-product');
    const btnAddLogo = $('#btn-add-logo');

    let totalItems = 0;
    let payloadAddToCart;
  
    if (customizeProduct.length){
      customizeProduct.html('loaded');
    }


    castleLoadSizes();

    $(document).on('change','input[name="options[Color]"]',function(){
      castleLoadSizes();
    });

    function castleLoadSizes(){
      var selectedColor = $('input[name="options[Color]"]:checked').val();

      $('.current-size').html(' (' + selectedColor + ')');

      $('[data-color]').removeClass('active');
      $('[data-color="' + selectedColor + '"]').addClass('active');
      castleCheckAddLogo();
      $('.castle-quantity-selector input').val(0);
    }

     $(document).on('change','.castle-quantity-selector input',function(){
       castleCheckAddLogo();
     });
  
    // Minus button action
    $('.castle-quantity-selector .qty-btn.minus').click(function() {
      var $input = $(this).siblings('.qty-input');
      var currentVal = parseInt($input.val());
      if (currentVal >= 1){
        $input.val(currentVal - 1);
      }
      
      castleCheckAddLogo();
    });

  
  
    // Plus button action
    $('.castle-quantity-selector .qty-btn.plus').click(function() {
      var $input = $(this).siblings('.qty-input');
      var currentVal = parseInt($input.val());
      var maxVal = parseInt($input.attr('max'));
      if (currentVal < maxVal){
        $input.val(currentVal + 1);
      }
      castleCheckAddLogo();
    });

    $(document).on('blur','.qty-input',function(){
        const max = parseInt($(this).attr('max')); // Convert max to an integer
        const val = parseInt($(this).val()); // Convert input value to an integer
      
        if (val > max) {
          $(this).val(max); // Reset to the max value
          alert("You can't enter greater than available stocks.");
        }
    });

    
    
    function castleCheckAddLogo(){
      // Count Active Size Quantity
      var activeSizes = $('.castle-variant-selector-size tr.active');
      totalItems = 0;
      payloadAddToCart = {};
      payloadAddToCart.items = [];

      $.each(activeSizes,function(){
        const variantID = $(this).attr('data-variant-id');
        const variantQuantity = parseInt($(this).find('input').val());
        
        totalItems+= variantQuantity;

        if (variantQuantity > 0){
          payloadAddToCart.items.push({
            id: variantID,
            quantity: variantQuantity
          });
        }
        
      });

      console.log('Castle payload',payloadAddToCart);
      console.log('Castle totalItems',totalItems);

      if (totalItems >= 5){
        btnAddLogo.prop('disabled',false);
      }else{
        btnAddLogo.prop('disabled',true);
      }
    }

    // Add Logo
    $(document).on('click','#btn-add-logo',function(){

        // Open directly via API
      $.magnificPopup.open({
         items: {
              src: '#castle-customize-information-popup',
              type: 'inline'
          },
        closeOnBgClick: false
      });
      
      
    });

    $(document).on('click','#btn-continue-add-logo',function(){
      const button = $(this);
      
      // Open directly via API
      $.magnificPopup.open({
         items: {
              src: '#castle-customize-product-popup',
              type: 'inline'
          },
        closeOnBgClick: false
      });
    });
  

    
    // Default add to Cart
    $(document).on('click','#btn-add-to-cart',function(){

      if (totalItems > 0){
        
        const button = $(this);
        button.prop('disabled',true).html('Please wait...');
  
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: payloadAddToCart,
          dataType: 'json',
          success: function(data) {
            button.prop('disabled',false).html('Add to Cart');
            castleLoadSizes();
            window.location.href = '/cart';
          },
          error: function(error) {
            console.log('Error adding to cart:', error);
          }
        });

      }
      
    });


    var currentStep = 1;

    // Customize Product - #btn-customer-status
    $(document).on('click','#btn-customer-status',function(){
        const status = $(this).attr('data-status');

        localStorage.setItem('castle_customize_new_customer',status);

        addNewCustomerFee();
      
        currentStep = 2;
        stepToggle();
    });

    const localStorageKey = 'castle_customize_new_customer';
    const variantId = 54881769226615; // Variant ID for the new customer fee
    const feeQuantity = 1; // Quantity of the fee to add

    // Function to add new customer fee
    function addNewCustomerFee() {
      console.log('addNewCustomerFee');


      // If the fee is already in the cart, remove it first (set quantity to 0)
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: {
            [variantId]: 0
          }
        },
        dataType: 'json',
        success: function() {
          console.log('Existing fee removed or set to 0.');
          if (localStorage.getItem(localStorageKey) === 'yes') {
            addFeeToCart();
          }
        }
      });
      
    }
  
    // Function to add the fee variant to the cart
    function addFeeToCart() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { 
          quantity: feeQuantity, 
          id: variantId 
        },
        dataType: 'json',
        success: function() {
          console.log('New customer fee added to the cart.');
        },
        error: function(error) {
          console.error('Error adding fee to cart:', error);
        }
      });
    }

    function stepToggle(){

      
      $('[data-step]').hide();
      $('[data-step="' + currentStep +'"]').show();

      if (currentStep === 2){
        $('.btn-finish').prop('disabled',false);
      }
    }


    // Cutomize Product -application-method
    $(document).on('click','.application-method',function(){
      $('.application-method').removeClass('active');
      $(this).addClass('active');
    });
  
    $(document).on('click','.btn-nav-step',function(){
      const goToStep = $(this).attr('data-go-step');
      currentStep = goToStep;
      stepToggle();
    });

    // Customize upload - step upload

    let uploadType = '';
  
    $(document).on('click','.step-upload',function(){
      $('.step-upload').removeClass('active');
      $(this).addClass('active');

      uploadType = $(this).attr('data-action');

      $('.step-upload-funnel').removeClass('active');
      $('.step-upload-funnel[data-action="' + $(this).attr('data-action') + '"]').addClass('active');

      $('#btn-add-another-logo,.btn-finish').prop('disabled',true);
      
      switch (uploadType){
        case 'text':
          if ($('.step-upload-funnel-text input[name="text_line"]').val().length > 0){
            $('#btn-add-another-logo,.btn-finish').prop('disabled',false);
          }
        break;

        case 'logo':


          const fileInput = $('.step-upload-funnel-image input[name="step-upload-file"]');

          if (fileInput.length) { // Check if the element exists
              if (fileInput[0].files && fileInput[0].files.length > 0) {
                  console.log('File is selected:', fileInput[0].files[0].name);
              } else {
                  $('#btn-add-another-logo,.btn-finish').prop('disabled',false);
              }
          } else {
              $('#btn-add-another-logo,.btn-finish').prop('disabled',false);
          }

          
          
          
        break;
          
      }
    });


    

    // Image Text
    let uploadFunnelText = {
      elements: {
        wrapper: $('.step-upload-funnel-text'),
        textLine: $('.step-upload-funnel-text input[name="text_line"]'),
        font: $('.step-upload-funnel-text select[name="font"]'),
        color: $('.step-upload-funnel-text select[name="color"]'),
        preview: $('.step-upload-funnel-text .step-text-preview .text-line'),
        properties: {
          "Customise Method" : $('.application-method.active .title').html(),
          "Customise Type" : 'Text',
          "Customise Position Name" : '',
          // "Customise Position Product ID" : '',
          "Customise Position Variant ID" : '',
          // "Customise Position Variant Price" : '',
          "Customise Text Line" : '',
          "Customise Font Style" : 'normal',
          "Customise Font Colour" : 'black',
          "Customise Note" : ''
        }
      },
      init: function() {

        this.applyStyling();

        this.elements.properties["Customise Text Line"] = this.elements.textLine.val();
        
        this.elements.textLine.on('keyup', (event) => {
          const textValue = $(event.target).val();
          this.elements.preview.html(textValue);

          if (textValue.length > 0){
            $('#btn-add-another-logo,.btn-finish').prop('disabled',false);
            this.elements.properties["Customise Text Line"] = textValue;
          }else{
            $('#btn-add-another-logo,.btn-finish').prop('disabled',true);
          }
          
        });

        this.elements.font.on('change', () => {
          this.applyStyling();
        });
        this.elements.color.on('change', () => {
          this.applyStyling();
        });

        
        
      },
      applyStyling: function(){
        let css = {
          'font-style': this.elements.font.val(),
          'color': this.elements.color.find('option:selected').val(),
          'background-color': this.elements.color.find('option:selected').attr('data-background')
        }
        this.elements.preview.css(css);

        
        this.elements.properties["Customise Font Style"] = this.elements.font.val();
        this.elements.properties["Customise Font Colour"] = this.elements.color.find('option:selected').val();
        
        
        
      }
    };


    let uploadFunnelImage = {
      elements: {
        wrapper: $('.step-upload-funnel-image'),
        properties: {
          "Customise Method" : $('.application-method.active .title').html(),
          "Customise Type" : 'Image',
          "Customise Position Name" : '',
          "Customise Position Variant ID" : '',
          "Customise Image URL" : '',
          "Customise Note" : ''
        }
      },
      init: function() {

        // Upload Image
        const allowedExtensions = ['jpg', 'png', 'eps', 'ai', 'pdf'];
        const previewExtensions = ['jpg', 'png'];
        const maxFileSize = 8 * 1024 * 1024; // 8MB
      
        $('#file').on('change', function () {
            const fileInput = this.files[0];
      
            // Clear preview and response
            $('#preview').hide();
            $('#upload-response').html('');
      
            if (!fileInput) {
                $('#upload-response').html('<p style="color: red;">Please select a file to upload.</p>');
                return;
            }
      
            // Extract file details
            let fileName = fileInput.name;
            const fileSize = fileInput.size;
            const fileExtension = fileName.split('.').pop().toLowerCase();
      
            // Override filename
            fileName = $('[name="step-upload-file"]').attr('data-logo-id');
      
            // Validate file extension
            if (!allowedExtensions.includes(fileExtension)) {
                $('#upload-response').html('<p style="color: red;">Invalid file type. Allowed types: JPG, PNG, EPS, AI, PDF.</p>');
                return;
            }
      
            // Validate file size
            if (fileSize > maxFileSize) {
                $('#upload-response').html('<p style="color: red;">File size exceeds the maximum limit of 8MB.</p>');
                return;
            }
      
            // Show file details
            $('#file-info').html(`File: ${fileName} (${(fileSize / (1024 * 1024)).toFixed(2)} MB)`);
      
            // Show preview for JPG and PNG
            if (previewExtensions.includes(fileExtension)) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    $('#preview-image').attr('src', e.target.result);
                    $('#preview').show();
                };
                reader.readAsDataURL(fileInput);
            } else {
                $('#preview').hide();
            }
      
            // Upload the file immediately to the server
            const formData = new FormData();
            formData.append('filename', fileName);  // Include desired filename
            formData.append('file', fileInput);
      
            $.ajax({
                url: apiEndpoint + '/api.php?t_=' + getRandomSixDigitNumber(),  // Your API endpoint
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#upload-response').html('<p style="color: green;">' + response.message + '</p>');

                    
                    if (response.file_path) {
                        const imageURL = apiEndpoint + response.file_path;
                        $('#upload-response').append('<p>Uploaded file: <a href="' + imageURL + '" target="_blank">' + response.file_path + '</a></p>');
                        uploadFunnelImage.elements.properties["Customise Image URL"] = imageURL;
                    }
                },
                error: function (xhr) {
                    const errorMessage = xhr.responseJSON ? xhr.responseJSON.message : 'An error occurred.';
                    $('#response').html('<p style="color: red;">' + errorMessage + '</p>');
                }
            });
        });
      
        // Handle manual form submission (optional)
        $('#uploadForm').on('submit', function (e) {
            e.preventDefault();
            // You can add any additional logic if necessary for form submission here.
        });

        
        
      }
    };
    
    uploadFunnelText.init();
    uploadFunnelImage.init();

    $(document).on('click','.step-position',function(){
      $('.step-position').removeClass('active');
      $(this).addClass('active');
      currentStep = '3a';
      stepToggle();


      let logoID = getRandomSixDigitNumber();
      $(this).attr('data-logo-id',logoID);
      $('[name="step-upload-file"]').attr('data-logo-id',logoID);
      

      let applicationMethod = $('.application-method.active .title').html();
      $(this).attr('data-application-method',applicationMethod.toLowerCase());

      // Images Clear
      $('#upload-response, #preview').html('');
      $('.step-upload-funnel-image input[name="step-upload-file"]').val('')

      // Note Clear
      $('#customise-position-note').val('');

      // Set Title
      $('.step-position-title').html($(this).find('.title').html());
      

      uploadFunnelText.elements.properties["Customise Position Name"] = $('.step-position.active .title').html();
      uploadFunnelText.elements.properties["Customise Position Variant ID"] = $('.step-position.active').attr('data-' + applicationMethod.toLowerCase() + '-variant-id'); 

      uploadFunnelImage.elements.properties["Customise Position Name"] = $('.step-position.active .title').html();
      uploadFunnelImage.elements.properties["Customise Position Variant ID"] = $('.step-position.active').attr('data-' + applicationMethod.toLowerCase() + '-variant-id'); 

      
    });

    // Add Another Logo - set property
    $(document).on('click','#btn-add-another-logo',function(){

      setPositionProperties();
      currentStep  = 2;
      stepToggle();
        
    });

    let groupID = new Date().getTime();

  
    // Add Another Logo - set property / create payload
    $(document).on('click','.btn-finish',function(){

      setPositionProperties();

      payloadAddToCart = {};
      payloadAddToCart.items = [];


      let lineItemProperties = {};
      let lineItemCustomizeProducts = [];

      lineItemProperties['Customise Group ID'] = groupID;
      // lineItemProperties['Customise Product Type'] = 'Main Product';

      // Prepare Properties
      $.each($('.step-position.uploaded'),function(index){

        let count = index + 1;
        let dataProperties = JSON.parse($(this).attr('data-properties'));

        console.log('dataProperties',dataProperties);

        // Logo ID
        let logoID = $(this).attr('data-logo-id');
        lineItemProperties['Customise Logo ID' + ' #' + count] = logoID;
  
        let updatedProperties = {};
        for (let key in dataProperties) {
          if (dataProperties.hasOwnProperty(key)) {
            lineItemProperties[key + ' #' + count] = dataProperties[key];
          }
        }

        lineItemCustomizeProducts.push({
            variant_id : dataProperties['Customise Position Variant ID'],
            quantity : totalItems,
            logo_id : logoID
        });

      });

      console.log('lineItemCustomizeProducts',lineItemCustomizeProducts);

      // Get Variant with QTY
      var activeSizes = $('.castle-variant-selector-size tr.active');
      
      $.each(activeSizes,function(){
        const variantID = $(this).attr('data-variant-id');
        const variantQuantity = parseInt($(this).find('input').val());

         const color = $('.castle-input-color:checked').val();
        const size = $(this).find('.size-option').html();
        const productTitle = $('.product-block__title').html();
        const productName = productTitle + ' ' + size + ' / ' + color;
        
       

        if (variantQuantity > 0){
          payloadAddToCart.items.push({
            id: variantID,
            quantity: variantQuantity,
            properties: lineItemProperties
          });

          // Customise Position
          $.each(lineItemCustomizeProducts, function(index, item) {

             let subGroupID = getRandomSixDigitNumber();
             payloadAddToCart.items.push({
                id: item.variant_id,
                quantity: variantQuantity,
                properties: {
                  'Customise Group ID' : groupID,
                  'Customise Product Name' : productName,
                  'Customise Parent Variant ID' : variantID,
                  'Customise Logo ID' : item.logo_id
                }
              });
          });
        }

        

        
      });

      

      console.log('Customise payloadAddToCart',payloadAddToCart);
      const button = $(this);
      button.prop('disabled',true).html('Please wait...');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: payloadAddToCart,
        dataType: 'json',
        success: function(data) {
          button.prop('disabled',false).html('Finish');
          castleLoadSizes();
          window.location.href = '/cart';
        },
        error: function(error) {
          console.log('Error adding to cart:', error);
        }
      });
      
      
  
      
    });


    

    function setPositionProperties(){
      
      switch (uploadType){
        case 'text':
          uploadFunnelText.elements.properties["Customise Note"] = $('#customise-position-note').val();
          const productPropertiesText = uploadFunnelText.elements.properties;          
          $('.step-position.active').attr('data-properties',JSON.stringify(productPropertiesText)).addClass('uploaded').removeClass('active');
        break;

        case 'logo':
          uploadFunnelImage.elements.properties["Customise Note"] = $('#customise-position-note').val();
          const productPropertiesImage = uploadFunnelImage.elements.properties;
          $('.step-position.active').attr('data-properties',JSON.stringify(productPropertiesImage)).addClass('uploaded').removeClass('active');
        break;
      }

      
    
    }


  // Function to generate a random 6-digit number
  function getRandomSixDigitNumber() {
      return Math.floor(100000 + Math.random() * 900000);
  }

  $(document).on('click','.castle-input-color',function(){
    const id = $(this).attr('data-id');
    const $targetThumbnail = $('[data-media="' +id+'"]');
    
    if ($targetThumbnail.length) {
      // Find the parent element with the class .product-gallery__navigation-thumbnail
      const $parentThumbnail = $targetThumbnail.closest('.product-gallery__navigation-thumbnail');
    
      if ($parentThumbnail.length) {
    
        // Simulate a click on the parent element
        $parentThumbnail.trigger('click');
      } else {
        console.error('Parent element with class .product-gallery__navigation-thumbnail not found.');
      }
    } else {
      console.error('Thumbnail with data-media="45017137479885" not found.');
    }

    
  });


  
    
    
  
});